<template>
  <el-card id="RecipeRecordTab">
    <template #header>
      <h4>{{ $t('菜谱记录') }}</h4>
    </template>

    <el-tabs v-model="activeName">
      <template v-for="item in comps">
        <el-tab-pane :key="item.name" :label="`${$t(item.label)}（${item.count}）`" :name="item.name">
          <recipe-record-list
              :type="item.type"
              :tab-current="item.name"
              :current="activeName"
              :column-list="item.columnList" />
        </el-tab-pane>
      </template>
    </el-tabs>
  </el-card>
</template>

<script>
import RecipeRecordList from "@/components/user/RecipeRecordList";
import {request} from "@/config/request";
export default {
  name: "RecipeRecordTab",
  components: {RecipeRecordList},
  data() {
    return {
      activeName: null,
      comps: [
        {
          name: "collectCount",
          label: "收藏的菜谱",
          count: 0,
          type: "collect",
          columnList: [
            {label: "收藏时间", prop: "collectTimeStr"},
          ]
        },
        {
          name: "useCount",
          label: "使用的菜谱",
          count: 0,
          type: "use",
          columnList: [
            {label: "制作时间", prop: "useTimeStr"},
          ]
        },
        {
          name: "payCount",
          label: "购买的菜谱",
          count: 0,
          type: "pay",
          columnList: [
            {label: "支付金额", prop: "payPrice"},
            {label: "支付时间", prop: "payTimeStr"},
          ]
        },
        {
          name: "rewardCount",
          label: "打赏的菜谱",
          count: 0,
          type: "reward",
          columnList: [
            {label: "打赏金额", prop: "rewardPrice"},
            {label: "支付时间", prop: "rewardTimeStr"},
          ]
        },
        {
          name: "evaluateCount",
          label: "评价的菜谱",
          count: 0,
          type: "evaluate",
          columnList: [
            {label: "评分", prop: "star"},
            {label: "评价时间", prop: "evaluateTimeStr"},
          ]
        },
        {
          name: "watchCount",
          label: "浏览的菜谱",
          count: 0,
          type: "watch",
          columnList: [
            {label: "浏览时间", prop: "watchTimeStr"},
          ]
        },
      ]
    }
  },
  methods: {
    // 加载用户菜谱统计数量
    async loadUserRecipeRecordCount() {
      try {
        const res = await request(this.$api.cookbook.countData, {userNum: this.$route.query.num});
        const countData = res.countMap;
        this.comps.forEach(item => {
          item.count = countData[item.name] || 0;
        })
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    // 监听组件是否出现在视口
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        console.log('组件出现在视口 RecipeRecordTab');
        this.loadUserRecipeRecordCount();
        this.activeName = "collectCount";
        this.observer.unobserve(document.getElementById("RecipeRecordTab"));
      }
    })

    this.observer.observe(document.getElementById("RecipeRecordTab"));
    this.$once('hook:beforeDestroy', () => {
      this.observer.disconnect();
    })
  },
}
</script>

<style scoped>

</style>
